// extracted by mini-css-extract-plugin
export default {"logoName":"navbar_logoName__INmsY","appbar":"navbar_appbar__ga9Tz","logo":"navbar_logo__2DXj2","navbarcontent":"navbar_navbarcontent__aqV0c"};